import "./12d0194078ec6ddc3ebfcba6aa400bf8.css";
export default {};